<template>
  <div class="workCodeInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      工單資訊
    </li>
    <b-table
      :items="workCodeInformationItem"
      :fields="workCodeInformationFields"
      class="text-center workCodeInformation-table-detail"
    >
      <!-- <template #cell(code)="row">
        {{ row.item["code"].code }}
        <br />
        ({{ row.item["code"].org_code }})
      </template> -->
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "workCodeInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workCodeInformationFields:
        "workCodeInformation/get_workCodeInformationFields",
      workCodeInformationItem:
        "workCodeInformation/get_workCodeInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.workCodeInformation-table-detail thead th {
  border-top: 1px solid;
}
.workCodeInformation-table-detail th,
.workCodeInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.workCodeInformation-table-detail th:first-child,
.workCodeInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.workCodeInformation-table-detail {
  margin-bottom: 0px;
}
.workCodeInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/workCodeInformation.vue